import { useContext, useEffect } from 'react';
import { ScaleLine } from '../../../../node_modules/ol/control';
import MapContext from '../MapContext';

const ScaleLineControl = () => {
  const { map } = useContext(MapContext);

  useEffect(() => {
    if (!map) return;

    let scaleLineControl = new ScaleLine({ maxWidth: 125 });

    map.controls.push(scaleLineControl);

    return () => {
      map.controls.remove(scaleLineControl);
    };
  }, [map]);

  return null;
};

export default ScaleLineControl;
